/***
 * Created on 2025/2/5
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useReducer} from 'react';
import {useTranslation} from "react-i18next";
import IftttDeviceItem from "./ifttt-device-item";
import {Tooltip} from "react-tooltip";
import IftttDeviceLogin from "./ifttt-device-login";

const initialState = {
    showDeviceList: true,
    showDeviceLogin: false,
};

function reducer(state, action) {
    if (action.type === 'toggleLoginDevice') {
        return {
            ...state,
            showDeviceLogin: action.payload,
            showDeviceList: false,
            device: action.data
        };
    }
    else if (action.type === 'toggleDeviceList') {
        return {
            ...state,
            showDeviceLogin: false,
            showDeviceList: action.payload
        };
    }
    else return state;
}


function IftttDeviceList({devices}) {
    const { t } = useTranslation();
    const [state, dispatch] = useReducer(reducer, initialState, () => initialState);

    const switchUser = () => {
        window.location.href = '/dauth/authorization/switch-user';
    }

    return (
        <>
            {
                state.showDeviceList &&
                    <div className="ifttt--login">
                        <div className="ifttt--login__subtitle">{t('@Choose from the list of accessible devices below to log in and grant access to {app_name}:@', {
                            app_name: 'IFTTT',
                            interpolation: {
                                prefix: '{',
                                suffix: '}',
                                escapeValue: false
                            }
                        })}</div>
                        <div className="common-info-grid">

                            {devices?.map((device, index) => <IftttDeviceItem key={device.device_id} device={device} state={state} dispatch={dispatch} isSingleDevice={devices?.length===1}/>)}

                        </div>
                        {/*This tooltip is for the component inside IftttDeviceItem to avoid overflow being covered */}
                        <Tooltip id="dauth-connect-error"/>

                        <div className="mt-16"><a onClick={switchUser}>{t('@Sign in with a different account@')}</a></div>
                    </div>
            }
            {
                state.showDeviceLogin && <IftttDeviceLogin state={state} dispatch={dispatch}/>
            }
        </>
    );
}

export default IftttDeviceList;